import React, { FC } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { ReactComponent as Mail } from './assets/mail.svg';
import { ReactComponent as InfoCircle } from './assets/info_circle.svg';
import { ToastProps, ToastType } from './interface';

const Toast: FC<ToastProps> = ({
  type,
  text,
  showToast,
  onConfirm,
  onDismiss,
}) => {
  const classes = useStyles({ type });
  const { t } = useTranslation();

  return showToast ? (
    <Box className={classes.mainContainer}>
      <Box className={classes.contentWrapper}>
        <Box className={classes.top}>
          <Box>
            {type === ToastType.INFO ? (
              <InfoCircle className={classes.icon} />
            ) : (
              <Mail className={classes.icon} />
            )}
          </Box>
          <Typography className={classes.content} variant="body2">
            {text}
          </Typography>
        </Box>
        <Box className={classes.buttonsWrapper}>
          <Button
            className={classes.button}
            variant="text"
            color="primary"
            onClick={onDismiss}
          >
            <Typography
              variant="body2"
              style={{ fontWeight: onConfirm ? 'normal' : 'bold' }}
            >
              {t('v2.global.button_label_dismiss')}
            </Typography>
          </Button>
          {!!onConfirm && (
            <Button
              className={classes.button}
              variant="text"
              color="primary"
              onClick={onConfirm}
            >
              <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                {t('v2.global.button_label_signUp')}
              </Typography>
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  ) : null;
};

export default Toast;
